(function () {
	'use strict';

	angular
		.module('dcApp')
		.controller('EntityCreatorController', EntityCreatorController);

	EntityCreatorController.$inject = [
		'$scope',
		'$rootScope',
		'$window',
		'EntityFromDepotService',
		'TypeEntiteService',
		'ParametersServices',
		'MetadataService',
		'toaster',
		'DATE_PATTERN',
		'DepotService',
		'CommonServices',
		'gettextCatalog',
	];

	function EntityCreatorController(
		$scope,
		$rootScope,
		$window,
		EntityFromDepotService,
		TypeEntiteService,
		ParametersServices,
		MetadataService,
		toaster,
		DATE_PATTERN,
		DepotService,
		CommonServices,
		gettextCatalog
	) {
		const vm = this;
		vm.createEntity = createEntity;

		init();

		// init EntiteType
		$scope.libs_lang = {};
		$scope.metadataLoaded = true;
		$scope.metadata = {};
		$scope.hide_preview = true;
		$scope.getDateWithPattern = $rootScope.getDateWithPattern;
		$scope.charsets = [];
		$scope.caracIsList = {};
		$scope.entiteTypeCaracs = [];
		$scope.selectedFileHeader = {};
		$scope.selectedEntiteTypeCarac = {};
		$scope.selectedHeaderType = {};
		$scope.createRepDetails = false;
		$scope.creationLoading = false;
		$scope.metadataConfig = {
			htmlId: 'uet-express',
		};
		$scope.metadataLoaded = false;

		$scope.setSelectedEntiteTypeCarac = function (carac, index) {
			setSelectedEntiteTypeCarac(
				carac,
				index,
				$scope.caracIsList,
				$scope.selectedFileHeader,
				$scope.mappings,
				$scope.selectedEntiteTypeCarac
			);
		};

		$scope.generateMetadata = function () {
			$scope.metadataLoaded = true;
			$scope.metadata.actif = true;
			$scope.metadataLoaded = true;
		};

		$scope.setSelectedType = function (carac) {
			setSelectedType(carac, $scope.defaultTypes);
		};

		$scope.setSelectedConnector = function (connector) {
			setSelectedConnector(connector, $scope.connexions, $scope.depot);
		};

		$scope.updateCaracLib = function (carac, lib) {
			carac.label = lib;
		};

		$scope.getHeaderReadableType = function (type, code) {
			if ($scope.caracIsList[code]) {
				return 'Liste(' + getHeaderRealReadableType(type, gettextCatalog) + ')';
			} else {
				return getHeaderRealReadableType(type, gettextCatalog);
			}
		};

		$scope.itemTracker = function (item) {
			return item.code + '-' + _.uniqueId();
		};

		function createHeadersAndCarac(data) {
			$scope.headers = data;
			$scope.entiteTypeCaracs = _.map($scope.headers, function (element) {
				return createCarac(element.column, element);
			});
			incrementAndUpdateDuplicatedValues($scope.entiteTypeCaracs, 'code');
			angular.forEach($scope.entiteTypeCaracs, function (carac) {
				$scope.caracIsList[carac.code] = $scope.caracIsList[carac.oldCode];
				carac.list =
					$scope.caracIsList[carac.code] != undefined
						? $scope.caracIsList[carac.code]
						: false;
				delete $scope.caracIsList[carac.oldCode];
			});
		}

		function closeModal(reload) {
			vm.showEntiteFromDepot = false;
			$scope.selectedFileHeader = {};
			$scope.selectedEntiteTypeCarac = {};
			$scope.selectedFileHeaderFormula = {};
			$scope.depot = {};
			delete $scope.gridData;
			$scope.entiteTypeFileHeader = [];
			$scope.disableMetaDataCode = false;
			$scope.reset();
			$scope.libs_lang = {};
			$scope.createRepDetails = false;
			$scope.creationLoading = false;
		}

		// Get necessary data and show the modal
		function initData() {
			// Get simpleTypes
			$scope.entiteTypeFileHeaderTypeMap = {};
			TypeEntiteService.getSimpleTypes().then(function (response) {
				let simpleTypes = $rootScope.translateSimpleTypes(response.data);
				$scope.defaultTypes = simpleTypes;
				$scope.simpleTypes = {};
				$scope.typeMapper = {};
				mapSimpleTypes(simpleTypes, $scope.typeMapper, $scope.simpleTypes);
				DepotService.getHeadersByDepotId(
					vm.entityFromDepot.depotId,
					vm.entityFromDepot.depotType
				).then(function (responseHeaders) {
					let headers = responseHeaders.data;
					CommonServices.getDateReadingMasks().then(function (responseMasks) {
						$scope.datePatterns = responseMasks.data;
						$scope.generateMetadata();
						createHeadersAndCarac(headers);
					});
				});
			});
		}

		function init() {
			initData();
			$rootScope.$on('entity-creator:closeModal', function () {
				vm.$accept();
			});
		}

		function createEntity() {
			saveAll();
		}

		function saveAll() {
			let entiteTypeCaracsCopy = angular.copy($scope.entiteTypeCaracs);
			let data = {};
			let caracs = [];
			let mapping = [];
			angular.forEach($scope.selectedEntiteTypeCarac, function (carac, key) {
				if (!carac.depotDetails) {
					updateGeneratedCarac(carac);
					let caracData = carac;
					let caracCode =
						caracData.tempCode != undefined
							? caracData.tempCode
							: caracData.code;
					let headerCarac =
						caracData && caracData.header
							? { id: angular.copy(caracData.header.id) }
							: null;
					delete caracData.header;
					if (
						headerCarac != undefined &&
						headerCarac != '' &&
						headerCarac != null
					) {
						let caracMapping = {};
						caracMapping.is_formula = false;
						caracMapping.header = headerCarac;
						caracMapping.pattern =
							caracData.date_pattern &&
							caracData.entite_type.code == 'SIMPLE_TYPES_DATE_ITEM'
								? caracData.date_pattern
								: undefined;
						caracMapping.uca_code = caracData.origin_column_id;
						caracMapping.linkId = $scope.linkId;
						mapping.push(caracMapping);
						caracs.push(caracData);
					}
				}
			});
			data.entity = $scope.metadata;
			// set tags default colors
			for (let t in data.entity.tags) {
				data.entity.tags[t].color =
					data.entity.tags[t].color !== undefined
						? data.entity.tags[t].color
						: '#dbf5d1';
			}
			data.caracs = caracs;
			data.mappings = mapping;
			let entiteTypeFileHeaderCopy = angular.copy($scope.entiteTypeFileHeader);
			$scope.creationLoading = true;
			EntityFromDepotService.createEntityFromDepot(
				vm.entityFromDepot.depotId,
				$scope.createRepDetails,
				data
			)
				.then(function (response) {
					$scope.entiteTypeCaracs = entiteTypeCaracsCopy;
					$scope.entiteTypeFileHeader = entiteTypeFileHeaderCopy;
					angular.forEach($scope.entiteTypeCaracs, function (element) {
						$scope.setSelectedEntiteTypeCarac(element, element.code);
					});
					$rootScope.$broadcast('entity-creator:closeModal');
					toaster.pop(
						'success',
						gettextCatalog.getString('Succès'),
						gettextCatalog.getString("Création de l'entité effectuée")
					);
					actionsAfterEntityExpress(response.data, vm);
					closeModal(true);
				})
				.catch(function () {
					// used to keep mapping filled even if an error occurred
					$scope.entiteTypeCaracs = entiteTypeCaracsCopy;
					$scope.entiteTypeFileHeader = entiteTypeFileHeaderCopy;
					$scope.creationLoading = false;
					angular.forEach($scope.entiteTypeCaracs, function (element) {
						$scope.setSelectedEntiteTypeCarac(element, element.code);
						$scope.setSelectedType(element);
					});
				});
		}

		function createCarac(carac, header) {
			let caracData = {};
			let caracCode = carac.metaCodeValidator();

			caracData.code = '_' + caracCode;
			caracData.code = caracData.code.toUpperCase();
			caracData.tempCode = caracData.code;
			caracData.oldCode = carac;
			caracData.entite_type = {};
			caracData.entite_type.id = $scope.typeMapper[header.data_type];
			caracData.entite_type = $scope.simpleTypes[caracData.entite_type.id];
			caracData.poids = 100;
			caracData.lib = carac;
			caracData.label = carac;
			caracData.complex = false;
			caracData.header = header;
			caracData.depotDetails = header.depot_details;
			if (caracData.date_pattern == undefined) {
				for (let t in $scope.datePatterns) {
					if ($scope.datePatterns[t].value == 'ISO 8601') {
						caracData.date_pattern = $scope.datePatterns[t].value;
						break;
					}
				}
			}

			return caracData;
		}
	}
})();
